import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    position: "relative",
    minHeight: "80vh",
    // TODO: add constant
    paddingTop: 70,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  header: {
    width: "-webkit-fill-available",
    display: "flex",
    position: "fixed",
    top: 0,
    alignItems: "center",
    padding: theme.spacing.space16,
    paddingInlineStart: theme.spacing.space8,
    gap: theme.spacing.space8,
    background: theme.colors.Background1,
    zIndex: theme.zIndex.appBar,
    justifyContent: "space-between",
  },
  icon: {
    padding: theme.spacing.space8,
  },
  container: {
    display: "grid",
  },
  tabs: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
  },
  videoList: {
    padding: theme.spacing.space16,
    display: "flex",
    gap: theme.spacing.space24,
    maxWidth: "100vw",
    boxSizing: "border-box",
    flexDirection: "column",
  },
}));
